export default __webpack_public_path__ + "static/media/paisajes.a32f30b1.jpg";